export const getProjectProgress = (project) => {
  const milestones = project?.milestones || [];
  if (!milestones.length) return 0;
  return Math.round((milestones.filter((item) => item.status === 'completed').length / milestones.length) * 100);
};

export const getNextMilestone = (project) => {
  const milestones = project?.milestones || [];
  return milestones.find((item) => item.status === 'approval_needed')
    || milestones.find((item) => item.status !== 'completed')
    || null;
};

export const getProjectAction = (project) => {
  if (project?.status === 'completed') return { label: 'Project completed', status: 'completed' };
  const next = getNextMilestone(project);
  if (!next) return { label: 'Add the next milestone', status: 'pending' };
  if (next.status === 'approval_needed') return { label: `${next.title} · awaiting client approval`, status: 'approval_needed' };
  return { label: next.title, status: 'in_process' };
};

export const flattenProjects = (clients = []) => clients.flatMap((client) => (
  (client.projects || []).map((project) => ({
    ...project,
    clientId: client.id,
    clientName: client.name,
    clientEmail: client.email,
    projectManager: client.assignedProjectManager || '',
  }))
));

export const projectPath = (project) => `/portal/clients/${project.clientId || project.owner}/projects/${project._id}`;

export const formatDate = (value, fallback = 'No date') => {
  if (!value) return fallback;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;
  return date.toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' });
};

export const timeAgo = (value) => {
  if (!value) return 'No recent activity';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'No recent activity';
  const seconds = Math.max(0, Math.floor((Date.now() - date.getTime()) / 1000));
  if (seconds < 60) return 'Just now';
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  if (seconds < 604800) return `${Math.floor(seconds / 86400)}d ago`;
  return formatDate(value);
};

export const projectLastActivity = (project) => project.updatedAt || project.completedAt || project.startDate;
